export const brands = {
  fastestform: {
    id: 'fastestform',
    name: 'TheFastestForm',
    shortName: 'Fasttttt',
    layout: 'navbar',
    logo: '/tff-logo-w.png',
    logoFallback: 'TF',
    domain: 'app.thefastestform.com',
    apiDomain: 'api.thefastestform.com',
    termsUrl: 'https://www.thefastestform.com/terms.html',
    intercomAppId: 'j42u5mlv',
    features: {
      forms: true,
      pages: true,
      crm: true,
      chat: true,
      deals: true,
      workflows: true,
      chatbots: true,
      prospecting: true,
    },
  },
  able: {
    id: 'able',
    name: 'Able',
    shortName: 'Able',
    layout: 'sidebar',
    logo: '/able-logo.svg',
    icon: '/able-icon.svg',
    logoFallback: 'A',
    domain: 'app.runonable.com',
    apiDomain: 'api.runonable.com',
    termsUrl: 'https://www.runonable.com/terms',
    intercomAppId: null,
    features: {
      forms: true,
      pages: true,
      crm: true,
      chat: true,
      deals: true,
      workflows: true,
      chatbots: true,
      prospecting: true,
    },
  },
};

export const detectBrandFromHostname = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('runonable.com')) return 'able';
  if (hostname.includes('thefastestform.com')) return 'fastestform';
  return process.env.REACT_APP_DEFAULT_BRAND || 'fastestform';
};
